import React from 'react';
import { Loading, Container, Text, Button, InputField } from '../../components';
import { Input } from "@amigoapp/doca-react";
import { formatPhone, formatDate } from '../../utils/formatter';
import { GENDER } from '../../constants/patient';

function PatientExistsForm({
	loading,
	isValid,
	values,
	onChangeWithMask,
	onSubmitClick,
	variant,
	handleNavigateBackPress,
	patientNotFound,
	setFieldValue
}) {
	if (loading) {
		return <Loading />;
	}

return (
	<Container padded>
		<Text size="large" weight="semibold" marginBottom={8}>Dados pessoais</Text>

		<Text marginBottom={24} variant="gray">
			{patientNotFound
				? 'Paciente não encontrado. Preencha os dados adicionais para continuar.'
				: 'Preencha o número do seu telefone para dar continuidade no agendamento'
			}
		</Text>

		<form onSubmit={onSubmitClick}>
			<InputField
				label="Celular"
				name="contact_cellphone"
				value={values?.contact_cellphone}
				type="tel"
				maxLength={15}
				className="doca-form__field doca-form__field--required"
				required
				disabled={patientNotFound}
				onChange={event => onChangeWithMask(event, formatPhone)}
				placeholder="(00) 00000-0000"
			/>

			{patientNotFound && (
				<>
					<Input
						label="Data de nascimento"
						name="born"
						value={values?.born}
						className="doca-my-2"
						required
						type="tel"
						onChange={event => onChangeWithMask(event, formatDate)}
						placeholder="DD/MM/AAAA"
					/>

					<div className="doca-form__field doca-form__field--required doca-mb-4">
						<label className="doca-form__label">
							Sexo
						</label>
						<div className="doca-flex doca-flex-row doca-justify-between doca-gap-4">
							<button
								type="button"
								className={`doca-shortcut w-100 ${values.gender === GENDER.male ? `doca-shortcut--${variant}` : ''}`}
								onClick={() => setFieldValue('gender', GENDER.male)}
							>
								<div>
									<i className="doca-icon doca-icon--large doca-icon__person" />
									<p className="doca-shortcut__title">
										Masculino
									</p>
								</div>
							</button>

							<button
								type="button"
								className={`doca-shortcut w-100 ${values.gender === GENDER.female ? `doca-shortcut--${variant}` : ''}`}
								onClick={() => setFieldValue('gender', GENDER.female)}
							>
								<div>
									<i className="doca-icon doca-icon--large doca-icon__person-dress" />
									<p className="doca-shortcut__title">
										Feminino
									</p>
								</div>
							</button>
						</div>
					</div>
				</>
			)}

			<Button
				block
				size="large"
				disabled={!isValid}
				marginBottom={16}
				variant={variant}
				type="submit"
				marginTop={24}
			>
				Continuar
			</Button>

			<Button
				block
				size="large"
				onClick={handleNavigateBackPress}
				variant='secondary'
				type="button"
			>
				<i className="doca-icon doca-icon__arrow-left"></i>
				Voltar
			</Button>
		</form>
	</Container>
	);
}

export default PatientExistsForm;
